export default __webpack_public_path__ + "static/media/angle-down-solid.8b5211ef.svg";